import apiService from '../utils/apiService';

import {
  GET_DECISION_ATTACHMENT,
  GET_DECISION_ATTACHMENT_START,
  GET_DECISION_ATTACHMENT_ERROR,
  GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW,
  GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_START,
  GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR,
  REMOVE_ATTACHMENT,
  CLEAR_ERROR_DECISION_ATTACHMENT,
} from './types';

import {
  decisionAttachmentFindByDecisionPath,
  downloadDecisionAttachmentPath,
  attachmentFindPath,
} from '../constants/apiEndpoints';
import { createNotification } from '../utils';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';

const clearError = () => {
  return {
    type: CLEAR_ERROR_DECISION_ATTACHMENT,
  };
};

const unmountAttachment = () => {
  return {
    type: REMOVE_ATTACHMENT,
  };
};

const getDecisionAttachmentStart = () => {
  return {
    type: GET_DECISION_ATTACHMENT_START,
  };
};
const getDecisionAttachmentSuccessfully = (data) => {
  return {
    type: GET_DECISION_ATTACHMENT,
    payload: data,
  };
};
const getDecisionAttachmentUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_ATTACHMENT_ERROR,
    payload: err,
  };
};

const getDecisionAttachmentContentForPreviewStart = () => {
  return {
    type: GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_START,
  };
};

const getDecisionAttachmentContentForPreviewSuccessfully = (data) => {
  return {
    type: GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW,
    payload: data,
  };
};

const getDecisionAttachmentContentForPreviewUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR,
    payload: err,
  };
};

const downloadAttachmentSuccessfuly = (data, decisionName, messages) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', decisionName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
  messages &&
    createNotification(
      notificationTypeSuccess,
      messages.decisionFinalTitle,
      messages.successDownload
    );
};

export const findDecisionAttachmentByDecision = (decisionId) => {
  return (dispatch) => {
    dispatch(getDecisionAttachmentStart());
    return apiService
      .get(decisionAttachmentFindByDecisionPath(decisionId))
      .then((response) => {
        dispatch(getDecisionAttachmentSuccessfully(response.data));
        dispatch(
          findDecisionAttachmentByName(
            response.data.embeddableAttribute.uuidName,
            'decisionAttachment'
          )
        );
      })
      .catch((err) => {
        dispatch(getDecisionAttachmentUnsuccessfully(err?.response?.data));
      });
  };
};

export const removeAttachment = () => {
  return (dispatch) => {
    dispatch(unmountAttachment());
  };
};

export const deleteErrorDecisionAttachment = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const downloadDecisionAttachment =
  (uuidDocName, decisionName, message) => (dispatch) => {
    return apiService
      .getFromFile(downloadDecisionAttachmentPath(uuidDocName))
      .then((response) => {
        dispatch(
          downloadAttachmentSuccessfuly(response.data, decisionName, message)
        );
      })
      .catch((err) => {
        dispatch(getDecisionAttachmentUnsuccessfully(err?.response?.data));
        if (err?.response?.status === 400) {
          createNotification(
            notificationTypeError,
            message.decisionTitleError,
            message.unsuccessDownload
          );
        }
      });
  };

export const findDecisionAttachmentByName = (name, controllerReference) => {
  return (dispatch) => {
    dispatch(getDecisionAttachmentContentForPreviewStart());
    return apiService
      .get(attachmentFindPath(name, controllerReference))
      .then((response) => {
        dispatch(
          getDecisionAttachmentContentForPreviewSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getDecisionAttachmentContentForPreviewUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};
